document.addEventListener('DOMContentLoaded', function () {

    document.querySelectorAll('.btb-top-bar .swiper').forEach(function (slider) {
        const autoRotate = slider.dataset.autoRotate === 'true';
        const slidesSpeed = Number(slider.dataset.slidesSpeed) * 1000;

        new Swiper(slider, {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: false,
            speed: 1000,
            autoplay: autoRotate ? {
                delay: slidesSpeed,
                disableOnInteraction: false
            } : false,
            breakpoints: {
                768: {
                    slidesPerView: 2
                },
                992: {
                    slidesPerView: 3
                }
            },
            navigation: {
                nextEl: slider.querySelector('.swiper-button-next'),
                prevEl: slider.querySelector('.swiper-button-prev')
            }
        });
    });

    document.querySelectorAll('.image-slideshow .swiper').forEach(function (slider) {
        const autoRotate = slider.dataset.autoRotate === 'true';
        const slidesSpeed = Number(slider.dataset.slidesSpeed) * 1000;

        const pagination = slider.querySelector('.swiper-pagination');

        new Swiper(slider, {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: false,
            speed: 1000,
            autoplay: autoRotate ? {
                delay: slidesSpeed,
                disableOnInteraction: false
            } : false,
            pagination: pagination ? {
                el: pagination,
                clickable: true
            } : false
        });
    });
    
});


/* document.addEventListener('DOMContentLoaded', () => {
    const productGridContainer = document.getElementById('ProductGridContainer');

    if (!productGridContainer) return;

    const bindPagination = () => {
        const paginationLinks = productGridContainer.querySelectorAll('.pagination a[href]');

        paginationLinks.forEach((link) => {
            if (link.dataset.ajaxPagination === 'true') return;

            link.dataset.ajaxPagination = 'true';

            link.addEventListener('click', (event) => {
                event.preventDefault();

                const url = new URL(link.href, window.location.origin);
                const searchParams = url.searchParams.toString();

                FacetFiltersForm.renderPage(searchParams);

                productGridContainer.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            });
        });
    };

    bindPagination();

    const observer = new MutationObserver(() => {
        bindPagination();
    });

    observer.observe(productGridContainer, {
        childList: true,
        subtree: true
    });
}); */

document.addEventListener('DOMContentLoaded', () => {
    const productGridContainer = document.getElementById('ProductGridContainer');

    if (!productGridContainer) return;

    const bindPagination = () => {
        const paginationLinks = productGridContainer.querySelectorAll(
            '.pagination--modern a[href]'
        );

        paginationLinks.forEach((link) => {
            if (link.dataset.ajaxPagination === 'true') return;

            link.dataset.ajaxPagination = 'true';

            link.addEventListener('click', async (event) => {
                event.preventDefault();

                const url = new URL(link.href, window.location.origin);
                const searchParams = url.searchParams.toString();

                const currentItems = productGridContainer.querySelectorAll(
                    '.grid__item'
                );

                const currentLastItem = currentItems[currentItems.length - 1];

                const loadingOverlay = document.querySelector(
                    '.collection .loading-overlay'
                );

                // Show loading overlay
                if (loadingOverlay) {
                    loadingOverlay.style.display = 'block';
                }

                try {
                    const response = await fetch(
                        `${window.location.pathname}?${searchParams}`
                    );

                    if (!response.ok) {
                        throw new Error(response.status);
                    }

                    const html = await response.text();

                    const parser = new DOMParser();
                    const doc = parser.parseFromString(html, 'text/html');

                    // Get products from the next page
                    const newItems = doc.querySelectorAll(
                        '#ProductGridContainer .grid__item'
                    );

                    // Append new products
                    newItems.forEach((item) => {
                        currentLastItem.insertAdjacentHTML(
                            'afterend',
                            item.outerHTML
                        );
                    });

                    // Replace pagination with the next page pagination
                    const newPagination = doc.querySelector(
                        '.pagination--modern'
                    );

                    const currentPagination = productGridContainer.querySelector(
                        '.pagination--modern'
                    );

                    if (newPagination && currentPagination) {
                        currentPagination.outerHTML = newPagination.outerHTML;
                    } else if (currentPagination) {
                        currentPagination.remove();
                    }

                    // Initialise lazy-loaded images
                    if (window.initLazyImages) {
                        window.initLazyImages();
                    }

                    // Bind the new pagination links
                    bindPagination();
                    
                } catch (error) {
                    console.error(
                        'Unable to fetch pagination results',
                        error
                    );
                } finally {
                    // Hide loading overlay
                    if (loadingOverlay) {
                        loadingOverlay.style.display = 'none';
                    }
                }
            });
        });
    };

    bindPagination();

    const observer = new MutationObserver(() => {
        bindPagination();
    });

    observer.observe(productGridContainer, {
        childList: true,
        subtree: true
    });
});

/* document.addEventListener('click', (event) => {
    const swatch = event.target.closest('.color-swatch');

    if (!swatch) return;

    event.stopPropagation();

    const imageUrl = swatch.dataset.image;

    if (!imageUrl) return;

    const card = swatch.closest('.card-wrapper');
    const image = card?.querySelector('.card__media img');

    if (!image) return;

    // Change image
    image.src = imageUrl;
    image.srcset = imageUrl;

    // Set active swatch
    card.querySelectorAll('.color-swatch').forEach((item) => {
        item.classList.remove('active');
    });

    swatch.classList.add('active');
}); */

document.querySelectorAll('.snippets').forEach((element) => {
    if (element.children.length === 0 && !element.textContent.trim()) {
        element.style.display = 'none';
    }
});